<button class="button-blue" type="button" (click)="openInviteDialog()">
  <lucide-angular name="user-plus" [size]="18"></lucide-angular>

  {{ "administration.inviteMember.button" | translate }}
</button>
